import React, { useState } from 'react'
import { useParams } from 'react-router-dom'

import objectUtils from '../../_helpers/objectUtils'
import reactQuery from '../../_helpers/reactQuery'
import stringUtils from '../../_helpers/stringUtils'
import { newsService } from '../../_services'
import { types } from '../../constants'
import translate from '../../locales/en'
import Document from '../Abstract/Document'

const News = function () {
  const collectionName = 'News'
  const singleCollectionName = 'News'
  const queryKey = collectionName.toLowerCase()
  const singleQueryKey = singleCollectionName.toLowerCase()
  const params = useParams()
  const getQuery = reactQuery.getOneQuery(
    singleQueryKey,
    params.id,
    newsService.get
  )
  const updateMutation = reactQuery.updateMutation(
    newsService.update,
    params.id,
    singleCollectionName,
    singleQueryKey,
    queryKey
  )
  const deleteMutation = reactQuery.deleteMutation(
    newsService.remove,
    params.id,
    singleCollectionName,
    singleQueryKey,
    queryKey
  )
  const [body, setBody] = useState({})
  return (
    <Document
      actions={[
        {
          buttonLabel: `${translate.Update} ${translate[singleCollectionName]}`,
          buttonColor: 'primary',
          onSubmit: (args) => {
            const newBody = objectUtils.compare(getQuery.data, args)
            const { profilePicture, coverPicture } = newBody
            delete newBody.profilePicture
            delete newBody.coverPicture
            const formData = objectUtils.getFormData(newBody)
            if (profilePicture && profilePicture.length)
              Object.keys(profilePicture).forEach((key) =>
                formData.append('profilePicture', profilePicture[key])
              )
            if (coverPicture && coverPicture.length)
              Object.keys(coverPicture).forEach((key) =>
                formData.append('coverPicture', coverPicture[key])
              )
            if (
              Object.keys(newBody).length ||
              (profilePicture && profilePicture.length) ||
              (coverPicture && coverPicture.length)
            )
              return updateMutation.mutate(formData)
          },
          body,
          setBody,
          withClear: true,
          clearFunction: () => setBody({}),
          form: {
            title: `${translate.Update} ${translate[singleCollectionName]}`,
            inputs: [
              {
                name: 'name',
                label: 'Name',
                type: 'text',
                value: getQuery.data?.name,
              },
              {
                name: 'nameAR',
                label: 'Arabic Name',
                type: 'text',
                value: getQuery.data?.nameAR,
              },
              {
                name: 'description',
                label: 'Description',
                type: 'text',
                value: getQuery.data?.description,
              },
              {
                name: 'descriptionAR',
                label: 'Arabic Description',
                type: 'text',
                value: getQuery.data?.descriptionAR,
              },
              {
                name: 'type',
                label: 'Type',
                type: 'select',
                value: getQuery.data?.type,
                options: types.newsTypes.map((newsType) => ({
                  label: stringUtils.camelCase(newsType),
                  value: newsType,
                })),
              },
              {
                name: 'profilePicture',
                label: 'Profile Picture',
                type: 'file',
                accept: 'image/*',
              },
              {
                name: 'coverPicture',
                label: 'Cover Picture',
                type: 'file',
                accept: 'image/*',
              },
            ],
          },
        },
        {
          buttonLabel: `${translate.Delete} ${translate[singleCollectionName]}`,
          buttonColor: 'secondary',
          onSubmit: () => deleteMutation.mutate(),
          form: {
            title: `${translate.Delete} ${translate[singleCollectionName]}`,
          },
          confirm: true,
          info: `${translate['Are you sure you want to delete this']} ${translate[singleCollectionName]}`,
        },
      ]}
      title={singleCollectionName}
      getQuery={getQuery}
      many={false}
    />
  )
}
export default News
